import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import { colors, grey, mobile } from '../../styles/tokens';

/**
 * BottomNav - Navigation mobile style application native
 *
 * Props:
 * - navItems: Array of { label, icon, path }
 * - maxItems: Maximum items to show (default 5)
 * - maxWidth: Max-width for desktop centering (optional)
 */
const BottomNav = ({ navItems = [], maxItems = 5, maxWidth }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Limite le nombre d'items
  const displayItems = navItems.slice(0, maxItems);

  // Trouve l'index actif
  const getCurrentIndex = () => {
    const index = displayItems.findIndex(item => {
      if (!item.path) return false;
      // Match exact pour home et pages racines
      if (item.path === '/coach' || item.path === '/admin' || item.path === '/client') {
        return location.pathname === item.path;
      }
      return location.pathname.startsWith(item.path);
    });
    return index >= 0 ? index : 0;
  };

  const handleChange = (event, newValue) => {
    const item = displayItems[newValue];
    if (item?.path) {
      navigate(item.path);
    }
  };

  if (displayItems.length === 0) return null;

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        // IMPORTANT: width explicite pour eviter debordement
        width: '100%',
        maxWidth: '100vw',
        boxSizing: 'border-box',
        zIndex: 1100,
        borderTop: `1px solid ${colors.border}`,
        borderRadius: 0,
        // Safe area pour iPhone
        paddingBottom: mobile.safeAreaBottom,
      }}
      elevation={0}
    >
      <BottomNavigation
        value={getCurrentIndex()}
        onChange={handleChange}
        showLabels
        sx={{
          height: mobile.bottomNavHeight,
          bgcolor: colors.bgSurface,
          // Max-width pour desktop
          maxWidth: maxWidth || '100%',
          mx: 'auto',
          '& .MuiBottomNavigationAction-root': {
            minWidth: 'auto',
            padding: '6px 8px 8px',
            color: grey[400],
            transition: 'all 0.15s ease',
            '&.Mui-selected': {
              // Couleur active: noir au lieu de primary
              color: grey[900],
            },
            '& .MuiBottomNavigationAction-label': {
              fontSize: '0.625rem',  // 10px - plus petit
              fontWeight: 500,
              marginTop: '2px',
              transition: 'all 0.15s ease',
              '&.Mui-selected': {
                fontSize: '0.625rem',
                fontWeight: 600,
              },
            },
            '& .MuiSvgIcon-root': {
              // Icones reduites: 20px au lieu de 22px
              fontSize: '1.25rem',
            },
          },
        }}
      >
        {displayItems.map((item, index) => {
          const Icon = item.icon;
          return (
            <BottomNavigationAction
              key={index}
              label={item.label}
              icon={<Icon />}
            />
          );
        })}
      </BottomNavigation>
    </Paper>
  );
};

export default BottomNav;
